import { createStore } from "vuex";


const store = createStore({
    state() {
        return {
            dadosChamado: {},
            setores: {},
            config: {},
            tipoChamado: {}
        };
    },
    mutations: {
        setDadosChamado(state, value) {
            state.dadosChamado = value;
        },
        setConfig(state, value) {
            state.config = value;
        },
        setSetores(state, value) {
            state.setores = value;
        },
        setTipoChamado(state, value) {
            state.tipoChamado = value;
        }
    }
});

export default store;